import type * as React from "react";
import { Separator, type SeparatorProps } from "react-aria-components";
import { divider } from "./Divider.css.ts";

export type Variant = keyof typeof divider.classNames.variants.variant;

interface Props {
  /**
   * Thickness: `normal` or `thin` for more subtle separation.
   * @default "normal"
   */
  variant?: Variant;
  /**
   * Orientation of the divider.
   * @default "horizontal"
   */
  orientation?: SeparatorProps["orientation"];
  /** Ref to the underlying hr or div element. */
  ref?: React.Ref<HTMLHRElement | HTMLDivElement>;
}

/**
 * A visual separator line to divide content sections. Supports horizontal and vertical orientations.
 */
export const Divider: React.FC<Props> = ({
  variant = "normal",
  orientation = "horizontal",
  ref,
}) => (
  <Separator
    className={divider({ variant, orientation })}
    orientation={orientation}
    ref={ref}
  />
);
